module.exports = __webpack_public_path__ + "static/media/lock.b989d637.svg";